import React from 'react';
import { getDisplayName } from '../utils';
import { IntlProvider } from '../IntlProvider';
/**
 * React Higher Order Component to add locale props to a component
 */
export function withTestContext(messages, Component) {
    if (messages === undefined) {
        throw new Error([
            'You are calling withTestContext(Component) with an undefined component.',
            'You may have forgotten to import it.',
        ].join('\n'));
    }
    var newWrappedComponent;
    var newMessages;
    // React element passed as first arg
    if (React.isValidElement(messages)) {
        newWrappedComponent = messages;
        newMessages = {};
    }
    // Function returning React component passed as first arg
    else if (typeof messages === 'function') {
        newWrappedComponent = React.createElement(messages);
        newMessages = {};
    }
    // Function returning React component passed as second arg
    else if (typeof Component === 'function') {
        newWrappedComponent = React.createElement(Component);
        newMessages = messages;
    }
    // Message object and React Component passed as args
    else {
        newWrappedComponent = Component;
        newMessages = messages;
    }
    // Test localeData
    var localeData = {
        locale: 'en',
        localeMode: undefined,
        lang: 'en',
        currencyFormat: {
            baseCurrency: 'USD',
            currencySign: 'standard',
            symbolLocation: 'before',
            currencySymbol: '$',
        },
        dateFormat: {},
        messages: {},
        numberFormat: {
            delimiters: { thousands: ',', decimal: '.' },
            numberSign: 'standard',
        },
        timeFormat: { hour12: true, timeSeparator: ':', timeZone: 'America/New_York' },
        calendarFormat: {
            firstWeekDay: 1,
            startDayHour: 8,
            endDayHour: 17,
            defaultCalView: 2,
        },
        distanceUnit: 'M',
    };
    var WithTestContext = React.forwardRef(function WithTestContext() {
        return (React.createElement(IntlProvider, { localeData: localeData, messages: newMessages }, newWrappedComponent));
    });
    WithTestContext.displayName = "WithTestContext(".concat(getDisplayName(Component), ")");
    return WithTestContext;
}
